<template>
  <div class="sign_container">
    <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px">
      <el-form-item label="用户名称" prop="name">
        <el-input v-model="userForm.name"></el-input>
      </el-form-item>
      <el-form-item label="用户密码" prop="pass">
        <el-input v-model="userForm.pass" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validate">登录</el-button>
      </el-form-item>
    </el-form>
    <!-- <div class="right-info">
      <el-link href="/signup/" type="info">注册</el-link>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'signup',
  components: {
  },
  data () {
    return {
      userForm: {},
      rules: {
        name: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        pass: [
          { required: true, message: '请输入用户密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    validate () {
      this.$refs.userForm.validate(async (status, rule) => {
        if (status) {
          const resp = await this.signin()
          if (resp.user) {
            sessionStorage.token = resp.token
            this.$router.push('/')
          } else {
            this.$message({
              message: resp.error,
              type: 'warning'
            })
          }
        }
      })
    },
    async signin () {
      const { userForm } = this
      const resp = await this.$http.post('/signin/', userForm)
      return resp
    }
  }
}
</script>

<style lang="scss" scoped>
.sign_container {
  position: relative;
  margin: 100px auto;
  width: 400px;

  .right-info {
    padding: 10px;
    text-align: right;
  }
}
</style>
